<template>
    <v-card>
        <div v-padding="3">
            <v-text type="headline">
                Упс! Такой страницы нет
            </v-text>
        </div>
    </v-card>
</template>

<script>
    export default {
        name: 'not-found',
    }
</script>


// WEBPACK FOOTER //
// 404.vue?638e72fc